
import { call, put, takeLatest, select } from 'redux-saga/effects'
import {
    getAttributes as getAttributesApi,
    requestCampaign as requestCampaignApi,
    getProductSegment as getProductSegmentApi,
    pauseResumeUpdateCampaign,
    getCustomerCountApi,
} from '../../network/requests'
import {
    getProductSegmentSuccess,
    getProductSegmentError,
    getAttributesSuccess,
    getAttributesError,
    createNewCampaignSuccess,
    createNewCampaignError,
    setViewCampaignSelected,
    setTargetCustomerCount,
    getCustomerCountError
} from './createCampaignReducer'
import { showSummaryAction } from "../../components/CampaignSummary/campaignSummaryReducer"
import { showNavHeadersAction } from '../../components/NavBar/navBarReducer'
import { showLoader, hideLoader } from "../../components/Loader/loaderReducer"
import { showNudge, SEVEARITY_CONTS } from "../../components/Nudge/nudgeReducer"
import { getProductSegmentData } from './helpers'
import { campaignCTAs } from '../../utils/constants'

function* getProductSegment(action) {
    yield put(showLoader())
    try {
        const productSegment = yield call(getProductSegmentApi,action.payload)
        yield put(getProductSegmentSuccess(productSegment))
    } catch (e) {
        yield put(getProductSegmentError(e))
    } finally {
        yield put(hideLoader())
    }
}

function* getAttributes(action) {
    yield put(showLoader())
    try {
        const attributes = yield call(getAttributesApi,action.payload)
        yield put(getAttributesSuccess(attributes))
    } catch (e) {
        yield put(getAttributesError(e))
    } finally {
        yield put(hideLoader())
    }
}

function* createCampaign(action) {
    yield put(showLoader())
    let api = requestCampaignApi;
    let successMessage = "Campaign Request Sent Successfully"
    switch (action.payload.requestType) {
        case campaignCTAs.submitRequest:
            if (action.payload.campaignData?.campaignId) {
                api = pauseResumeUpdateCampaign;
                successMessage = "Campaign Updated successfully"
            }
            break;
        case campaignCTAs.sendForApproval:
            api = pauseResumeUpdateCampaign;
            break;
        case campaignCTAs.schedule:
        case campaignCTAs.pause:
        case campaignCTAs.resume:
        case campaignCTAs.update:
            api = pauseResumeUpdateCampaign
            successMessage = "Campaign Updated successfully"
            break;
        case campaignCTAs.decline:
            api = pauseResumeUpdateCampaign
            successMessage = "Campaign Request Declined successfully"
        default:
            break;  
    }
    try {
        const data = yield call(api, action.payload.campaignData)
        yield put(createNewCampaignSuccess(data))
        yield put(showNudge({
            message: successMessage,
            type: SEVEARITY_CONTS.success
        }))
        const summary = { ...action.payload.campaignData, ...data };
        yield put(showSummaryAction(summary))
        yield put(showNavHeadersAction())
        yield put(setViewCampaignSelected(summary));
    } catch (e) {
        yield put(createNewCampaignError(e?.error))
        yield put(showNudge({
            message: e?.error?.error || "Something went wrong",
            type: SEVEARITY_CONTS.error
        }))
    } finally {
        yield put(hideLoader())
    }
}

function* getCustomerCount(action) {
    try {
        const data = yield call(getCustomerCountApi, action.payload);
        yield put(setTargetCustomerCount(data?.count));
    } catch (e) {
        yield put(getCustomerCountError(e?.error?.error));
    }
}

function* createCampaignSaga() {
    yield takeLatest('CreateCampaign/getProductSegment', getProductSegment)
    yield takeLatest('CreateCampaign/getAttributes', getAttributes)
    yield takeLatest('CreateCampaign/createNewCampaign', createCampaign)
    yield takeLatest('CreateCampaign/getCustomerCount', getCustomerCount)
}

export default createCampaignSaga